<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                    label="合作协议名称"
                    :rules="rules.required"
                    v-model="item.name"/>
              </v-flex>

<!--              <v-flex xs12 sm6>-->
<!--                <x-user-select-form-->
<!--                    label="项目负责人"-->
<!--                    :rules="rules.required"-->
<!--                    v-model="leader"-->
<!--                    hint="输入关键词，检索添加本单位项目负责人；或直接录入外单位项目负责人。"-->
<!--                    persistent-hint-->
<!--                />-->
<!--              </v-flex>-->

              <v-flex xs12 sm6>
              <x-select-user
                  label="承办人"
                  v-model="leader"
                  :rules="rules.required"
                  persistent-hint
              />
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                    label="负责人联系电话"
                    :rules="rules.required"
                    v-model="item.leaderPhone"/>
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                    label="归属部门"
                    clearable
                    :rules="rules.required"
                    v-model="item.deptId"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems"
                />
              </v-flex>

              <!--暂时只获取科学技术院作为科技合作协议的管理部门-->
              <v-flex xs12 sm6>
                <v-select
                    label="主管部门"
                    required
                    readonly
                    :rules="rules.required"
                    v-model="item.adminDeptId"
                    hint = "主管部门系统默认为科学技术院"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems.filter(d => d.dbid === 'Db2NIJQbgCU')"
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-text-field
                    label="合作单位名称"
                    :rules="rules.normal"
                    v-model="item.client"
                />
              </v-flex>

              <v-flex xs12 sm4>
                <v-select
                    label="合作单位性质"
                    clearable
                    :rules="rules.required"
                    v-model="item.clientTypeId"
                    item-text="name"
                    item-value="dbid"
                    :items="orgnTypeItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-textarea
                    label="主要内容"
                    :rules="rules.required"
                    v-model="item.content"
                ></v-textarea>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                    label="合作协议校章用印数"
                    v-model="item.instSealNum"
                    :rules="rules.amount"
                />
              </v-flex>

              <v-flex xs6>
                <v-text-field
                    label="合作协议授权委托人章用印数"
                    v-model="item.prinSealNum"
                    :rules="rules.amount"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="备注"
                    v-model="item.note"
                />
              </v-flex>


              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(20)"
                    :description="[
                    '单个附件大小不超过 20M.',
                    '推荐上传 PDF 格式文件.'
                  ]"
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'

import XUploader from '@/components/global/Uploader'
//import XUserSelectForm from '@/components/global/UserSelectForm'
import XSelectUser from '@/components/ol_ctra/OlCtraUserSelect'

const baseURI = '/api/agmt/agreement';
const typeURI = '/api/proj/project-type';
const orgnTypeURI = '/api/agmt/orgn-type';
const deptURI = '/api/syst/department';
const indstTypeUri = '/api/proj/industry-type/flatten/tree';

export default {
  mixins: [mixin.edit(baseURI)],
  components: {XUploader, XSelectUser},

  data() {
    return {
      formValid: false,

      fileUri: '/api/agmt/file',

      item: {},
      freshItem: {
        "name": null,
        "adminDeptId": null,
        "deptId": null,
        "leaderId": null,
        "leaderName": null,
        "statusId": null,
        "typeId": null,
        "property": null,
        "trade": null,
        "client": null,
        "clientTypeId": null,
        "amount": null,
        "bidding": null,
        "applDate": null,
        "leaderPhone": null,
        "startDate": null,
        "finishDate": null,
        "turnover": null,
        "proj_num": null,   // 采购项目号 科技合作协议不需要此信息
        "fund_num":null,    // 项目经费号 科技合作协议不需要此信息
        "signatory":"那靖",   // 我校签约人,默认那靖
        "fund_src":null,    // 经费来源 科技合作协议不需要此信息
        "content": "",      // 主要内容
        "htfb": "T",         // 是否已使用格式合同范本
        "htztzz": "T",       // 是否已核查合同主体资质
        "htwbnr": "T",       // 是否已核查合同文本内容
        "flfxtk": "T",       // 是否已核查法律风险条款
        "nrys": "T",         // 是否纳入学校预算，符合学校开支范围 科技合作协议不需要此信息
        "nrtyzb": "",        // 是否纳入学校统一招标，合同文本与招投标文件内容一致，合同签订单位、金额与招标结果一致 科技合作协议不需要此信息
        "wsjj": "",          // 是否属于政府采购网上竞价（电商）采购项目，无中标通知书，合同模板为学校推荐文本 科技合作协议不需要此信息
        "dlyj": "T",         // 合同订立的依据是否存在
        "dsrsh": "T",        // 合同当事人是否适格
        "clqb": "T",         // 合同的签订材料是否完备齐全
        "wfgd": "F",         // 合同内容是否违反国家政策或者学校规定
        "cyhtfb": "T",       // 是否采用格式合同范本或者是否对格式合同范本主要条款作实质性变更
        "agmtType": "GkDCqB_hEAY", //合同类型 科技合作协议不需要此信息,默认科研类合同
        "instSealNum": "",  //校章用印数
        "prinSealNum": "",  //授权委托人章用印数
      },

      leader: {},

      startDateMenu: false,
      startDate: null,

      endDateMenu: false,
      finishDate: null,

      typeItems: [],
      orgnTypeItems: [],
      deptItems: [],

      indstTypeItems: [],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        bidding: [
          v => (v === true || v === false) || '必填项。'
        ],
        normal: [
          v => !!v || '必填项。',
          v => (v && v.length <= 100) || '长度必须小于100个字符。'
        ],
        amount: [
          v => !!v || '必填项。',
          v => (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
        ],
        email: [
          v => (!v || /^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
        ],

        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        finishDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },

  created() {
    this.indstTypeLoading = true;

    this.axios.all([
      this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
      // 只取 横向合同 的子项
      this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F', parentId: 'Db2NlYTLADg'}}),
      this.axios.get(orgnTypeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      this.axios.get(indstTypeUri)
    ]).then(
        this.axios.spread(
            (rspDept, rspType, rspOrgnType, rspIndst) => {
              this.deptItems = rspDept.data.items;
              this.typeItems = rspType.data.items;
              this.orgnTypeItems = rspOrgnType.data.items;

              this.indstTypeLoading = false;
              this.indstTypeItems = rspIndst.data.reduce(
                  (acc, v, i) => {
                    if (!v.leaf) {
                      if (i > 0)
                        acc.push({divider: true}, {header: v.name});
                      else
                        acc.push({header: v.name});
                    } else {
                      acc.push(v);
                    }
                    return acc;
                  }, []);
            }
        )
    )
  },

  watch: {
    "leader": function (v) {
      if (v) {
        this.item.leaderId = v.dbid;
        this.item.leaderName = v.name;

        //限制主管部门只能是科学技术院
        this.item.adminDeptId = 'Db2NIJQbgCU'

        // ✅ 新增：从 deptRoles[0] 取 departmentId
        if (v && Array.isArray(v.deptRoles) && v.deptRoles.length > 0) {
          this.item.deptId = v.deptRoles[0].department.dbid;
        } else {

        }

        if (v && v.phone) this.item.leaderPhone = v.phone;
      }
    }
  },

  methods: {
    // mixin 加载数据后调用
    afterGetData(data) {
      window.console.log("data")
      window.console.log(data)
      this.leader = {
        dbid: data.leaderId,
        name: data.leaderName
      }
    },
  }
}
</script>
